import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from '@/App.vue'
import router from '@/router'
import { useAuthStore } from '@/stores/auth'
import '@/styles/classical.css'
import '@/styles/app.css'

const app = createApp(App)
app.use(createPinia())
void useAuthStore().init()
app.use(router)
app.mount('#app')
